import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card-item-details" }
const _hoisted_2 = { class: "d-flex align-center justify-space-between" }
const _hoisted_3 = { class: "font-size-12-600" }
const _hoisted_4 = { class: "font-size-14-600" }
const _hoisted_5 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_6 = { class: "font-size-10-600" }
const _hoisted_7 = { class: "d-flex justify-space-between font-size-10-400 font-danger mt-1" }
const _hoisted_8 = { class: "font-size-12-400" }
const _hoisted_9 = { class: "font-black font-size-12-400" }
const _hoisted_10 = {
  key: 0,
  class: "text-right pr-2"
}

import {computed, ref, onMounted} from 'vue';
import Icon from "@/components/Icons/Icon.vue";

import minBy from 'lodash/minBy';
import isEmpty from 'lodash/isEmpty';


export default /*@__PURE__*/_defineComponent({
  __name: 'ShopCartServicePackageDetails',
  props: {
  item: {
    type: Object,
  },
  disabled: {
    type: Boolean,
    default: false
  },
  isLastItem: {
    type: Boolean,
    default: false
  },
  justifyEnd: {
    type: Boolean,
    default: false
  }
},
  emits: ['delete'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

const showMore = ref(false);
const isTextOverflowing = ref(false);
const descriptionContainer = ref<HTMLElement | null>(null);

const toggleText = () => {
  showMore.value = !showMore.value;

  // Toggle full text display when 'Show More' is clicked
  if (descriptionContainer.value) {
    if (showMore.value) {
      descriptionContainer.value.style.webkitLineClamp = 'unset';
    } else {
      descriptionContainer.value.style.webkitLineClamp = '3';
    }
  }
};

const getTitle = computed(() => {
  if (props.item?.product) {
    return props.item.product.name;
  }
  return props.item?.name;
});

const getImage = computed(() => {
  if (props.item?.product && props.item?.product?.image !== undefined) {
    return props.item?.product?.image?.file?.file_path ?? null;
  }
  return null;
});

const getIcon = computed(() => {
  const type = props.item.product?.type ?? null;
  if (type === 'clinic_service' || type === 'service') {
    return 'service-icon';
  }
  return 'package-icon';
});

const getPrice = computed(() => {
  return props.item.price_display ?? '-';
});

const isShipping = computed(() => {
  return props.item.product && props.item.product.type === 'shipping_method';
});

const getDescription = computed(() => {
  return props.item.product.description ?? '';
});

const getInstalments = computed(() => {
  if (props.item.product?.instalments === undefined || props.item.product?.instalments.length === 0) {
    return [];
  }
  return props.item.product.instalments;
});

const getFirstInstalment = computed(() => {
  if (!isEmpty(getInstalments.value)) {
    // Use lodash's minBy to get the instalment with the lowest "days"
    return minBy(getInstalments.value, 'days');
  }
  return null;
});

// Check for text overflow when the component is mounted
onMounted(() => {
  if (descriptionContainer.value) {
    const element = descriptionContainer.value;
    isTextOverflowing.value = element.scrollHeight > element.clientHeight;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (!isShipping.value)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass([{'border-bottom': !__props.isLastItem}, "pt-5"])
      }, [
        _createElementVNode("div", _hoisted_1, [
          (getImage.value)
            ? (_openBlock(), _createBlock(_component_v_sheet, {
                key: 0,
                class: "logo-container m-0"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    style: _normalizeStyle({backgroundImage: `url(${getImage.value})`}),
                    class: "logo-container__image"
                  }, null, 4)
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_v_sheet, {
                key: 1,
                class: _normalizeClass([{'secondary-background-button-color': !__props.item?.supplier }, "icon-container"])
              }, {
                default: _withCtx(() => [
                  _createVNode(Icon, { icon: getIcon.value }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["class"])),
          _createVNode(_component_v_card_text, { class: "pa-0" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("p", _hoisted_3, _toDisplayString(getTitle.value), 1),
                _createElementVNode("div", {
                  class: _normalizeClass({'disabled': __props.disabled}),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('delete')))
                }, [
                  _createVNode(Icon, { icon: "trash-icon" })
                ], 2)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass([{'justify-space-between mb-2': __props.justifyEnd}, "d-flex justify-end align-center mt-1 ga-2"])
              }, [
                _renderSlot(_ctx.$slots, "default"),
                _createElementVNode("p", _hoisted_4, _toDisplayString(getPrice.value), 1)
              ], 2),
              (getInstalments.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("p", _hoisted_6, "Instalments (1/" + _toDisplayString(getInstalments.value.length) + ")", 1),
                    _createElementVNode("div", _hoisted_7, [
                      _cache[1] || (_cache[1] = _createElementVNode("p", null, "Due Now", -1)),
                      _createElementVNode("p", _hoisted_8, _toDisplayString(__props.item.currency) + _toDisplayString(getFirstInstalment.value.amount), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 3
          })
        ]),
        _createVNode(_component_v_card_text, { class: "px-0 pb-2 d-flex ga-4" }, {
          default: _withCtx(() => [
            (__props.item?.product?.services?.length > 0)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 0,
                  cols: "4"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _cache[2] || (_cache[2] = _createElementVNode("p", { class: "font-size-12-600" }, "Services Included", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item?.product?.services, (service, index) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: `service-${index}`,
                          class: "my-2 font-size-12-400"
                        }, _toDisplayString(service.name), 1))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (getDescription.value)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 1,
                  class: "pr-3",
                  cols: "8"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      ref_key: "descriptionContainer",
                      ref: descriptionContainer,
                      class: "three-line-ellipsis font-grey-dark font-size-12-400 line-height-18"
                    }, " \"" + _toDisplayString(getDescription.value) + "\" ", 513),
                    (isTextOverflowing.value || showMore.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createVNode(_component_v_btn, {
                            ripple: false,
                            class: "primary-underline-button text-capitalize font-size-12-600 pa-0",
                            variant: "plain",
                            onClick: toggleText
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(showMore.value ? 'Show Less' : 'Show More'), 1)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 2))
    : _createCommentVNode("", true)
}
}

})